export default (): void => {
  const inputs = document.querySelectorAll<HTMLInputElement>(
    "input[data-trim-on-blur]"
  );
  inputs.forEach((input) => {
    input.addEventListener("blur", () => {
      input.value = input.value.trim();
    });
  });
};
